(() => {
  if (window.cmUsabilityReady) return;
  window.cmUsabilityReady = true;
  function init(root = document) {
    root.querySelectorAll('[data-service-guide]').forEach(guide => {
      if (guide.dataset.ready) return;
      const tabs = [...guide.querySelectorAll('[data-guide-choice]')];
      const panels = [...guide.querySelectorAll('[data-guide-panel]')];
      if (!tabs.length || tabs.length !== panels.length) return;
      guide.dataset.ready = 'true';
      guide.querySelector('[data-guide-tabs]').setAttribute('role', 'tablist');
      const select = (tab, focus = false) => {
        tabs.forEach(item => {
          const active = item === tab;
          item.setAttribute('role', 'tab');
          item.setAttribute('aria-selected', String(active));
          item.tabIndex = active ? 0 : -1;
        });
        panels.forEach(panel => {
          panel.setAttribute('role', 'tabpanel');
          panel.tabIndex = 0;
          panel.hidden = panel.dataset.guidePanel !== tab.dataset.guideChoice;
        });
        if (focus) tab.focus({preventScroll: true});
      };
      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => select(tab));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (i + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault(); select(tabs[next], true);
        });
      });
      select(tabs[0]);
    });
    root.querySelectorAll('[data-page-directory]').forEach(directory => {
      if (directory.dataset.ready) return;
      directory.dataset.ready = 'true';
      directory.addEventListener('click', event => {
        if (event.target.closest('a')) directory.open = false;
      });
    });
  }
  function revealDetails(hash) {
    let id;
    try { id = decodeURIComponent(hash.replace(/^#/, '')); } catch { return; }
    const target = document.getElementById(id);
    if (target?.matches('.cm-offer-terms details')) target.open = true;
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href^="#"]');
    if (link) revealDetails(link.hash);
  });
  window.addEventListener('hashchange', () => revealDetails(window.location.hash));
  document.addEventListener('DOMContentLoaded', () => { init(); revealDetails(window.location.hash); });
  document.addEventListener('shopify:section:load', event => init(event.target));
  if (document.readyState !== 'loading') init();
})();
